<template>
  <component :is="tag" class="hero-banner">
    <div class="section-inner">
      <StoryblokComponent
        v-if="blok.image?.[0]"
        :blok="blok.image[0]"
        :size-hint="90"
        :size-hint-mobile="92"
        :quality="isPrimaryHeroBanner ? 90 : undefined"
        :fetch-priority="isPrimaryHeroBanner ? 'high' : undefined"
        :loading="isPrimaryHeroBanner ? 'eager' : 'lazy'"
      />
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});

const { isPrimaryHeroBanner } = usePrimaryHeroBanner(
  props.blok._uid,
  props.blok.image?.[0]
);
</script>

<style lang="scss">
.background.background-hero-banner.alternate {
  background: var(--solid-07);
}
</style>

<style lang="scss" scoped>
.hero-banner {
  padding: 2.5rem 0 0 0;
  @include for-desktop-up {
    padding-top: 5rem;
    .section-inner {
      grid-column: 5/-5;
    }
    :deep(img) {
      aspect-ratio: 864/486;
    }
  }
  :deep(img) {
    display: block;
    width: 100%;
    border-radius: $radius-l;
  }
  :deep(.asset-image-with-caption) {
    figcaption {
      margin-top: 1rem;
      color: var(--text-70);
    }
  }
}
</style>
